import { makeStyles } from "@mui/styles";

import type { Theme } from "src/theme";

export const useSuperAdminSearchBarStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 300,
    },
    optionContainer: {
        padding: "0 !important",
    },
    option: {
        width: "100%",
        padding: theme.spacing(0.75, 2),
    },
}));
